import InfiniteLoad from './InfiniteLoad';
import Masonry from 'masonry-layout';
import { initCursorElements } from './customCursor';
import barba from '@barba/core';

(($) => {
    const initPostGrid = () => {
        const { rest_url, theme_url } = window.wkScriptVars;

        const loaderUrl = `${theme_url}/assets/dist/images/loader.svg`;
        const loaderImage = `<img src="${loaderUrl}" class="post-grid__loading-animation">`;

        const postGridBlocks = document.querySelectorAll(
            '.post-grid:not(.is-initialized)'
        );

        if (postGridBlocks.length) {
            postGridBlocks.forEach((postGridBlock) => {
                postGridBlock.classList.add('is-initialized');

                const postGrid =
                    postGridBlock.querySelector('[data-post-grid]');
                const postGridId = postGrid.dataset.postGrid;

                const $postGrid = $(postGrid);
                const $loaderWrapper = $(
                    '[data-post-grid-loader="' + postGridId + '"]'
                );

                const categorySelector = $(
                    '[data-post-filter-id="' + postGridId + '"]'
                );

                let layoutTimeOut;
                let masonryInstance;

                const {
                    filterable,
                    postGridType,
                    postGridOrder,
                    postGridMasonry,
                    postTypes,
                    taxonomies,
                    postsPerPage, // if switching category or pagination enabled it will requests this amount of posts
                    postsPerLoad, // only lazyload it will request this amount of posts
                    gridClasses,
                } = postGrid.dataset;

                if (postGridMasonry === 'true') {
                    const masonryConfig = {
                        columnWidth: '.post-teaser',
                        itemSelector: '.post-teaser',
                        gutter: 32,
                        percentPosition: true,
                        transitionDuration: '0.2s',
                    };
                    masonryInstance = new Masonry($postGrid[0], masonryConfig);
                }

                let filters = [];

                const loadMoreButton = postGridBlock.querySelector(
                    '[data-post-grid-load-more="' + postGridId + '"]'
                );

                const options = {
                    data: {
                        postsPerPage,
                        postsPerLoad,
                        postTypes,
                        postGridOrder,
                        taxonomies,
                        filters,
                        gridClasses,
                    },
                    container: $postGrid,
                    type: postGridType,
                    button: loadMoreButton,
                    callback: (data, done) => {
                        $loaderWrapper.html(loaderImage);

                        const response = $.ajax({
                            url: `${rest_url}wk-filters/v1/load_posts`,
                            method: 'POST',
                            data: {
                                ...data,
                            },
                        });

                        response.then((resp) => {
                            if (resp.has_next) {
                                $(loadMoreButton).show();
                            } else {
                                $(loadMoreButton).hide();
                            }

                            let newItems = null;

                            $loaderWrapper.html('');

                            if (resp.content !== '') {
                                const isNewContent = $postGrid.html() === '';
                                if (postsPerLoad == -1) {
                                    $postGrid.html('');
                                }

                                newItems = $(resp.content).appendTo($postGrid);

                                if (typeof layoutTimeOut !== 'undefined') {
                                    clearInterval(layoutTimeOut);
                                }

                                if (postGridMasonry === 'true') {
                                    newItems.css({
                                        opacity: 0,
                                        visibility: 'hidden',
                                    });
                                    if (isNewContent) {
                                        masonryInstance.reloadItems();
                                        masonryInstance.layout();

                                        setTimeout(() => {
                                            newItems.css({
                                                opacity: 1,
                                                visibility: 'visible',
                                            });
                                        }, 400);
                                    } else {
                                        masonryInstance.appended(newItems);
                                        layoutTimeOut = setTimeout(function () {
                                            masonryInstance.layout();
                                        }, 300);
                                        newItems.css({
                                            opacity: 1,
                                            visibility: 'visible',
                                        });
                                    }
                                }

                                if (isNewContent) {
                                    window.scrollTo({
                                        top:
                                            $postGrid.offset().top -
                                            $('.header').height() -
                                            180,
                                        behavior: 'smooth',
                                    });
                                }

                                window.dispatchEvent(
                                    new Event('postGridLoaded')
                                );
                            }
                            initCursorElements(postGridBlock);
                            done(resp);
                        });
                    },
                };

                const resetData = () => {
                    $postGrid.html('');
                    infiniteLoad.options.data.page = 0;
                    infiniteLoad.setFilters(filters);
                    infiniteLoad.reset();
                    infiniteLoad.load();

                    if (postGridMasonry === 'true') {
                        masonryInstance.reloadItems();
                        masonryInstance.layout();
                    }
                };

                const updateHash = () => {
                    if (filters.length) {
                        history.replaceState(
                            null,
                            null,
                            document.location.pathname + '#' + filters.join(',')
                        );
                    } else {
                        history.replaceState(
                            null,
                            null,
                            document.location.pathname
                        );
                    }
                };

                // setup infinite scroll
                let infiniteLoad = null;
                if ($postGrid.length > 0) {
                    infiniteLoad = new InfiniteLoad(options);
                    infiniteLoad.infiniteScroll();

                    categorySelector.on('click', function (e) {
                        e.preventDefault();

                        const filterValue = $(this).data('post-filter');
                        if (filterValue === 'all') {
                            filters = [];
                        } else {
                            const foundFilter = filters.indexOf(filterValue);

                            if (foundFilter !== -1) {
                                filters.splice(foundFilter, 1);
                                $(this).removeClass(
                                    'post-grid__tag-link--active'
                                );
                            } else {
                                filters = [];
                                $(
                                    '[data-post-filter-id="' +
                                        postGridId +
                                        '"].post-grid__tag-link--active'
                                ).removeClass('post-grid__tag-link--active');
                                filters.push(filterValue);
                                $(this).addClass('post-grid__tag-link--active');
                            }
                        }

                        if (filters.length === 0) {
                            $(
                                '[data-post-filter-id="' +
                                    postGridId +
                                    '"].post-grid__tag-link--active'
                            ).removeClass('post-grid__tag-link--active');
                            $(
                                '[data-post-filter-id="' +
                                    postGridId +
                                    '"][data-post-filter="all"]'
                            ).addClass('post-grid__tag-link--active');
                        } else {
                            $(
                                '[data-post-filter-id="' +
                                    postGridId +
                                    '"][data-post-filter="all"]'
                            ).removeClass('post-grid__tag-link--active');
                        }

                        updateHash();
                        resetData();
                    });

                    // Handling filters with hash
                    if (filterable === 'true' && window.location.hash) {
                        const hash = window.location.hash.substring(1);

                        if (hash.includes(',')) {
                            filters = hash.split(',');
                        } else {
                            filters = [hash];
                        }

                        $('.post-grid__tag-link--active').removeClass(
                            'post-grid__tag-link--active'
                        );

                        if (filters.length) {
                            filters.forEach((filter) => {
                                $(
                                    '[data-post-filter-id="' +
                                        postGridId +
                                        '"][data-post-filter="' +
                                        filter +
                                        '"]'
                                ).addClass('post-grid__tag-link--active');
                            });

                            resetData();
                        }
                    }
                }
            });
        }
    };

    barba.hooks.beforeEnter(initPostGrid);
    document.addEventListener('DOMContentLoaded', initPostGrid);
})(window.jQuery);
